export default __webpack_public_path__ + "static/media/vision.e44d40df.png";